// extracted by mini-css-extract-plugin
module.exports = {"info-list":"_5DvA27ai"};